const defaultHeaders = {
  Connection: "close",
  Accept: "application/json",
  "Content-Type": "application/json",
};

const apiFetch = (url, method, headers, body = null) => 
  fetch(url, {
    method: method,
    headers: headers,
    body: body ? JSON.stringify(body) : undefined,
  }).then((response) => response.json());

export const get = (url = "", headers = {}) =>
  apiFetch(url, "GET", { ...defaultHeaders, ...headers });

export const post = (url = "", body = {}, headers = {}) =>
  apiFetch(url, "POST", { ...defaultHeaders, ...headers }, body);

export const put = (url = "", body = {}, headers = {}) =>
  apiFetch(url, "PUT", { ...defaultHeaders, ...headers }, body);

export const patch = (url = "", body = {}, headers = {}) =>
  apiFetch(url, "PATCH", { ...defaultHeaders, ...headers }, body);

